// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GradeImprovementBlock_wrapper__2rb3P","mainBlock":"GradeImprovementBlock_mainBlock__1rjzE","mainTitle":"GradeImprovementBlock_mainTitle__3fZGV"};